import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/Button';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/1HY3DSYVqG3SwFku6ZfET4/c5c1e3c7-73c4-412d-b100-eab77e25f3ef.png';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-24 pb-10 lg:pt-28 lg:pb-16 overflow-hidden" data-id="element-145">
      <div className="container mx-auto px-4 relative z-10" data-id="element-146">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto" data-id="element-147">
          {/* Titulo + subtitulo */}
          <motion.div initial={{
          y: 20
        }} animate={{
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-148">
            <div className="mb-5 lg:mb-7 flex items-center justify-center gap-3" data-id="element-149">
              <span className="h-px w-6 sm:w-10 bg-gold/50" data-id="element-150"></span>
              <span className="text-gold text-xs sm:text-sm font-medium tracking-[0.25em] uppercase" data-id="element-151">
                Academia Holística Argentina
              </span>
              <span className="h-px w-6 sm:w-10 bg-gold/50" data-id="element-152"></span>
            </div>

            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 lg:mb-6" data-id="element-153">
              Formación Profesional{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-light via-gold to-gold-dark" data-id="element-154">
                en Tarot
              </span>
            </h1>

            <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-3 lg:mb-4 font-medium" data-id="element-155">
              Aprende Tarot Rider-Waite y Tarot de Marsella desde cero hasta un
              nivel profesional.
            </p>

            <p className="hidden sm:block text-white/70 mb-0 leading-relaxed max-w-2xl mx-auto" data-id="element-156">
              La formación más completa para interpretar las 78 cartas, realizar
              lecturas profesionales y desarrollar una práctica sólida mediante
              material 100% digital.
            </p>
          </motion.div>

          {/* Mockup centrado */}
          <motion.div initial={{
          scale: 0.96
        }} animate={{
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="relative my-4 lg:my-6 flex items-center justify-center w-full" data-id="element-157">
            <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(202,162,74,0.18),_transparent_65%)] rounded-full" data-id="element-158"></div>
            <img src={MOCKUP_URL} alt="MegaPack Tarot Profesional: caja, tomos, tablet, celular, cartas y elementos místicos" fetchPriority="high" decoding="async" className="relative w-full max-w-[320px] sm:max-w-md lg:max-w-xl max-h-[38vh] lg:max-h-[46vh] object-contain drop-shadow-2xl" data-id="element-159" />
          </motion.div>

          {/* CTA + beneficios */}
          <motion.div initial={{
          y: 20
        }} animate={{
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="w-full flex flex-col items-center" data-id="element-160">
            <div className="mb-4 lg:mb-8" data-id="element-161">
              <Button href="#pricing" size="lg" data-id="element-162">
                QUIERO ACCEDER AHORA
              </Button>
            </div>

            <div className="grid grid-cols-2 gap-2 sm:gap-4 justify-items-center" data-id="element-163">
              {['Acceso inmediato', 'Acceso de por vida', 'Certificado Digital', 'Material 100% PDF'].map((benefit, i) => <div key={i} className="flex items-center gap-2 text-xs sm:text-sm text-white/80" data-id="element-164">
                  <CheckCircle2 size={16} className="text-gold flex-shrink-0" data-id="element-165" />
                  <span data-id="element-166">{benefit}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}